export enum SsoLoginApplication {
    Account = 'account',
    Partner = 'partner',
}
